// Clipboard renderings of one insight (Kopieer on the slide, the copy buttons
// on the cards and in the Inhoud panel). Plain text for editors and chat,
// HTML so a paste into Docs/Slides keeps heading, bullets and quote styling.

function oneLine(v) {
  return String(v == null ? "" : v)
    .replace(/\s*\n\s*/g, " ")
    .trim();
}

function escapeHtml(v) {
  return String(v == null ? "" : v)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>");
}

// HTML rendering of one insight, so a paste into Docs/Slides keeps the
// heading, bullets and quote formatting.
export function insightToClipboardHtml(insight) {
  const ins = insight || {};
  const parts = [
    `<h2>${escapeHtml(oneLine(ins.title) || "Untitled insight")}</h2>`,
  ];
  if (oneLine(ins.topic))
    parts.push(`<p><em>${escapeHtml(oneLine(ins.topic))}</em></p>`);
  const findings = (ins.findings || [])
    .map((f) => String((f && f.text) || "").trim())
    .filter(Boolean);
  if (findings.length) {
    parts.push(
      `<ul>${findings.map((f) => `<li>${escapeHtml(f)}</li>`).join("")}</ul>`
    );
  }
  (ins.quotes || [])
    .filter((q) => q && String(q.text || "").trim())
    .forEach((q) => {
      const name = oneLine(q.name);
      parts.push(
        `<blockquote>“${escapeHtml(String(q.text).trim())}”${
          name ? ` — ${escapeHtml(name)}` : ""
        }</blockquote>`
      );
    });
  (ins.images || [])
    .filter((img) => img && String(img.url || "").trim())
    .forEach((img) => {
      parts.push(
        `<p><img src="${escapeHtml(String(img.url).trim())}" alt="${escapeHtml(
          oneLine(img.name)
        )}"></p>`
      );
    });
  return parts.join("\n");
}

// Plain-text rendering of one insight for the clipboard.
export function insightToClipboardText(insight) {
  const ins = insight || {};
  const out = [];
  out.push(`# ${oneLine(ins.title) || "Untitled insight"}`);
  if (oneLine(ins.topic)) out.push(`Topic: ${oneLine(ins.topic)}`);
  const findings = (ins.findings || [])
    .map((f) => String((f && f.text) || "").trim())
    .filter(Boolean);
  if (findings.length) {
    out.push("");
    findings.forEach((f) => out.push(`- ${f}`));
  }
  const quotes = (ins.quotes || []).filter(
    (q) => q && String(q.text || "").trim()
  );
  if (quotes.length) {
    out.push("");
    quotes.forEach((q) => {
      const name = oneLine(q.name);
      out.push(`> "${String(q.text).trim()}"${name ? ` — ${name}` : ""}`);
    });
  }
  return out.join("\n");
}
